import siteListSlice from './slice';

export const {
  fetchSiteListError,
  fetchSiteList,
  fetchSiteListSuccess,
  addSiteList,
  addSiteListSuccess,
  removeSiteList,
  removeSiteSuccess,
  getLastWebsiteAudit,
  getLastWebsiteAuditError,
  getLastWebsiteAuditSuccess,
  updateremoveSite,
  addSiteLisError,
  _updateAdSiteList,

  fetchCompanySiteList,
  fetchCompanySiteListError,
  fetchCompanySiteListSuccess,
} = siteListSlice.actions;
export default siteListSlice.reducer;

export * from './types';
